import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Charity from "../../assets/image/charity-removebg-preview.png";
import GiftCard from "../../assets/image/gift-removebg-preview.png";
import SaleOff from "../../assets/image/off-removebg-preview.png";

import bronzeCard from "../../assets/image/bronzeCard-removebg-preview.png";
import goldenCard from "../../assets/image/goldenCard-removebg-preview.png";
import silverCard from "../../assets/image/silverCard-removebg-preview.png";

export default function CurrencyCard({
  isDesktop,
  disableSelectBtn: isDisableSelectBtn = false,
  service,
  handleSelectService,
  ListOfCharence_Users,
  alert = null,
}) {
  const usercharense = JSON.parse(
    localStorage.getItem("userLevel")!
  )?.charense_Amount;
  const listOfColors = {
    gold: "#ffd700",
    goldbtn: "#d3bd48",
    silver: "#C0C0C0",
    silverbtn: "#7f7f7f",
    bronze: "#CD7F32",
    bronzebtn: "#886644",
  };

  const style = {
    formTitle: {
      fontWeight: "bold !important",
    },
    formDescription: {
      color: "#9b9b9b",
    },
    formContainer: {
      padding: "1rem !important",
      border: "3px solid #748DA6",
      borderRadius: "10px",
      backgroundColor: "#f1f7ff59",
      height: "auto",
    },
    gridBox: {
      display: "grid",
      gridTemplateColumns: "30rem 30rem 30rem",
      columnGap: "2%",
      justifyContent: "space-around",
      marginTop: "2rem",
    },
    mobileGridBox: {
      display: "grid",
      gridTemplateColumns: "auto",
      // columnGap:'5%',
      // rowGap:'7%',
      justifyContent: "center",
      marginTop: "2rem",
    },
    tabletGridBox: {
      display: "grid",
      gridTemplateColumns: "25rem 25rem",
      columnGap: "5%",
      justifyContent: "center",
      marginTop: "2rem",
    },
    modalStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      p: 4,
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      borderRadius: "3px",
      width: "30rem",
    },
    modalMobileStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      p: 4,
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      borderRadius: "3px",
      width: "15rem",
    },
    txtField: {
      width: "100%",
    },
    headerContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
    },
    stateHandler: {
      display: "flex",
      justifyContent: "center",
    },
    stateType: { fontWeight: "bold" },
    title: {
      display: "flex",
      justifyContent: "space-between",
      width: "65rem",
    },
    defineServices: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      width: "30rem",
      height: "80vh",
    },
    goldServiceBoxMobile: {
      // width:'100%',
      // padding:'0.5rem',
      // backgroundColor:listOfColors.gold+'a3',
      // border:`3px solid ${listOfColors.gold}`,
      // borderRadius:'0.3rem',
      // textAlign:'center'
      position: "relative",
      display: "inline-block",
    },
    silverServiceBoxMobile: {
      // width:'100%',
      // padding:'0.5rem',
      // backgroundColor:listOfColors.silver+'a3',
      // border:`3px solid ${listOfColors.silver}`,
      // borderRadius:'0.3rem',
      // textAlign:'center'
      position: "relative",
      display: "inline-block",
    },
    bronzeServiceBoxMobile: {
      // width:'100%',
      // padding:'0.5rem',
      // backgroundColor:listOfColors.bronze+'a3',
      // border:`3px solid ${listOfColors.bronze}`,
      // borderRadius:'0.3rem',
      // textAlign:'center'
      position: "relative",
      display: "inline-block",
    },
    goldServiceBox: {
      // width:'100%',
      // padding:'0.5rem',
      // background:`url('${require('../assets/image/goldenCard.png')}')`,
      // backgroundSize: 'cover',
      // backgroundRepeat: 'no-repeat',
      // backgroundPosition: 'center center',
      // border:`3px solid ${listOfColors.gold}`,
      // borderRadius:'0.3rem',
      position: "relative",
      display: "inline-block",
    },
    silverServiceBox: {
      // width:'100%',
      // padding:'0.5rem',
      // backgroundImage: `linear-gradient( ${listOfColors.silver}a3, ${listOfColors.silver}20)`,
      // border:`3px solid ${listOfColors.silver}`,
      // borderRadius:'0.3rem',
      position: "relative",
      display: "inline-block",
    },
    bronzeServiceBox: {
      // width:'100%',
      // padding:'0.5rem',
      // backgroundImage: `linear-gradient(${listOfColors.bronze}a3, ${listOfColors.bronze}6b)`,
      // border:`3px solid ${listOfColors.bronze}`,
      // borderRadius:'0.3rem',
      position: "relative",
      display: "inline-block",
    },
    goldServiceBtn: {
      backgroundColor: listOfColors.goldbtn,
    },
    silverServiceBtn: {
      backgroundColor: listOfColors.silverbtn,
    },
    bronzeServiceBtn: {
      backgroundColor: listOfColors.bronzebtn,
    },
    circleGold: {
      backgroundColor: "#ffe55c",
      borderRadius: "50%",
      padding: "0.5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "-1.5rem",
      marginLeft: "-1rem",
      border: `3px solid ${listOfColors.gold}`,
    },
    circleSilver: {
      backgroundColor: "#d7d7d7",
      borderRadius: "50%",
      padding: "0.5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "-1.5rem",
      marginLeft: "-1rem",
      border: `3px solid ${listOfColors.silver}`,
    },
    circleBronze: {
      backgroundColor: "#dfad7c",
      borderRadius: "50%",
      padding: "0.5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "-1.5rem",
      marginLeft: "-1rem",
      border: `3px solid ${listOfColors.bronze}`,
    },
    insideCard: {
      position: "absolute",
      top: "47%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "25rem",
    },
    insideCardMobile: {
      position: "absolute",
      top: "47%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "22rem",
    },
  };

  enum listOfLevels {
    "طلایی" = 1,
    "نقره ای" = 2,
    "برنزی" = 3,
  }

  const IconList = [
    <img style={{ width: "2rem" }} src={SaleOff} alt="" />,
    <img style={{ width: "2rem" }} src={Charity} alt="" />,
    <img style={{ width: "2rem" }} src={GiftCard} alt="" />,
  ];

  const is_Used = ListOfCharence_Users.find((x) => x.service_Id === service.id);

  const level_card = service.level_ID || service.level_Id;

  const statusChecker = () => {
    if (isDisableSelectBtn) {
      return "disableBtn";
    } else if (!service.isActive) {
      return "isNotActive";
    } else if (is_Used) {
      return "isUsed";
    } else if (+usercharense < +service.price_Service) {
      return "NotEnoughStock";
    } else {
      return "selectable";
    }
  };

  // useEffect(() => {
  //     console.log("usercharense", statusChecker(), usercharense, service.price_Service, usercharense < service.price_Service, service.title)

  // }, [statusChecker()])

  const [status, setStatus] = useState(statusChecker());

  const showStatus = () => {
    switch (status) {
      case "disableBtn":
        return null;
      case "isNotActive":
        return (
          <Box
            sx={{ display: "flex", textAlign: "left", justifyContent: "end" }}
          >
            <Typography
              disabled={true}
              variant="contained"
              style={{
                color: "red",
                background: "rgba(210, 210, 210, 0.8)",
                padding: "0 0.5rem ",
                borderRadius: "0.2rem",
              }}
            >
              غیرفعال
            </Typography>
          </Box>
        );
      case "isUsed":
        return (
          <Box
            sx={{ display: "flex", textAlign: "left", justifyContent: "end" }}
          >
            <Button
              disabled={true}
              variant="contained"
              style={{
                color: "green",
                background: "rgba(210, 210, 210, 0.8)",
                padding: "0 0.5rem ",
                borderRadius: "0.2rem",
              }}
              sx={
                level_card === 1
                  ? style.goldServiceBtn
                  : level_card === 2
                  ? style.silverServiceBtn
                  : style.bronzeServiceBtn
              }
            >
              انتخاب شده
            </Button>
          </Box>
        );
      case "NotEnoughStock":
        return (
          <Box
            sx={{ display: "flex", textAlign: "left", justifyContent: "end" }}
          >
            <Typography
              disabled={true}
              variant="contained"
              style={{
                color: "red",
                background: "rgba(210, 210, 210, 0.8)",
                padding: "0 0.5rem ",
                borderRadius: "0.2rem",
              }}
            >
              موجودی کافی نیست
            </Typography>
          </Box>
        );
      case "selectable":
        return (
          <Button
            disabled={
              !!ListOfCharence_Users.find((x) => x.service_Id === service.id)
            }
            variant="contained"
            style={{ border: "0.5px solid #fff" }}
            onClick={() => handleSelectService(service.id, level_card)}
            sx={
              level_card === 1
                ? style.goldServiceBtn
                : level_card === 2
                ? style.silverServiceBtn
                : style.bronzeServiceBtn
            }
          >
            انتخاب
          </Button>
        );
      default:
        return (
          <Button
            disabled={
              !!ListOfCharence_Users.find((x) => x.service_Id === service.id)
            }
            variant="contained"
            style={{ border: "0.5px solid #fff" }}
            onClick={() => handleSelectService(service.id, level_card)}
            sx={
              level_card === 1
                ? style.goldServiceBtn
                : level_card === 2
                ? style.silverServiceBtn
                : style.bronzeServiceBtn
            }
          >
            انتخاب
          </Button>
        );
    }
  };

  return (
    <>
      {isDesktop ? (
        <Box
          key={service.id}
          sx={
            level_card === 1
              ? style.goldServiceBox
              : level_card === 2
              ? style.silverServiceBox
              : style.bronzeServiceBox
          }
        >
          <img
            style={{
              width: "30rem",
              height: "13rem",
              filter:
                isDisableSelectBtn && !service.is_Used ? "blur(0.2rem)" : null,
            }}
            src={
              level_card === 1
                ? goldenCard
                : level_card === 2
                ? silverCard
                : bronzeCard
            }
            alt=""
          />
          <Box sx={style.insideCard}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                marginBottom: !isDisableSelectBtn ? "0.4rem" : "0.8rem",
                paddingBottom: !isDisableSelectBtn ? "0rem" : "1rem",
              }}
            >
              <Box
                sx={
                  level_card === 1
                    ? style.circleGold
                    : level_card === 2
                    ? style.circleSilver
                    : style.circleBronze
                }
              >
                {
                  IconList[
                    service.type_Id ? service.type_Id - 1 : service.type_ID - 1
                  ]
                }
              </Box>
            </Box>
            <Box
              sx={
                isDesktop
                  ? { display: "flex", justifyContent: "space-between" }
                  : {
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }
              }
            >
              <Box display="flex" flexDirection="column">
                <Typography variant="h6" sx={style.formTitle}>
                  {service.service_name}
                </Typography>
                <Typography variant="h6" sx={style.formTitle}>
                  {service.title}
                </Typography>
                {!service.is_Used && (
                  <Typography
                    variant="body1"
                    bgcolor={"rgba(211, 211, 225, 0.5)"}
                    sx={{ color: "red" }}
                  >
                    {alert}
                  </Typography>
                )}
              </Box>
              <Typography variant="h6">
                سطح :{listOfLevels[service.type_ID || service.type_Id]}
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                color: "#1e1e1e",
                fontWeight: "bold",
                margin: "0.2rem 0rem",
              }}
            >
              {service.price_Service &&
                ` تعداد کارنس : ${service.price_Service}`}
            </Typography>
            {showStatus()}
          </Box>
        </Box>
      ) : (
        <Box
          key={service.id}
          sx={
            level_card === 1
              ? style.goldServiceBoxMobile
              : level_card === 2
              ? style.silverServiceBoxMobile
              : style.bronzeServiceBoxMobile
          }
        >
          <img
            style={{ width: "25rem" }}
            src={
              level_card === 1
                ? goldenCard
                : level_card === 2
                ? silverCard
                : bronzeCard
            }
            alt=""
          />
          <Box sx={style.insideCardMobile}>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "end" }}>
              <Box
                sx={
                  level_card === 1
                    ? style.circleGold
                    : level_card === 2
                    ? style.circleSilver
                    : style.circleBronze
                }
              >
                {IconList[service.type_Id - 1]}
              </Box>
            </Box>
            <Box
              sx={
                isDesktop
                  ? { display: "flex", justifyContent: "space-between" }
                  : {
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }
              }
            >
              <Typography variant="h6" sx={style.formTitle}>
                {service.title}
              </Typography>
              <Typography variant="h6">
                سطح :
                {Object.keys(listOfLevels).find(
                  (key) => listOfLevels[key] === level_card
                )}
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                color: "#1e1e1e",
                fontWeight: "bold",
                margin: "0.7rem 0rem",
              }}
            >
              {service.price_Service &&
                ` تعداد کارنس : ${service.price_Service}`}
            </Typography>
            {!isDisableSelectBtn && (
              <Box
                sx={{
                  display: "flex",
                  textAlign: "left",
                  justifyContent: "end",
                }}
              >
                <Button
                  variant="contained"
                  disabled={
                    !!ListOfCharence_Users.find(
                      (x) => x.service_Id === service.id
                    )
                  }
                  onClick={() => handleSelectService(service.id, level_card)}
                  sx={
                    level_card === 1
                      ? style.goldServiceBtn
                      : level_card === 2
                      ? style.silverServiceBtn
                      : style.bronzeServiceBtn
                  }
                >
                  انتخاب
                </Button>
              </Box>
            )}
            {alert && (
              <Typography variant="body1" sx={{ color: "red" }}>
                {alert}
              </Typography>
            )}
          </Box>
        </Box>
      )}
    </>
  );
}
